import { VBtn } from 'vuetify/lib/components/VBtn';
import { VBtnToggle } from 'vuetify/lib/components/VBtnToggle';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VPagination } from 'vuetify/lib/components/VPagination';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    VContainer,
    [
      _vm._t("title"),
      _vm._v(" "),
      _c(
        VRow,
        [
          _vm._t("header", function () {
            return [
              _c(VSpacer),
              _vm._v(" "),
              _c(
                VBtnToggle,
                {
                  model: {
                    value: _vm.dataValue.layout,
                    callback: function ($$v) {
                      _vm.$set(_vm.dataValue, "layout", $$v)
                    },
                    expression: "dataValue.layout",
                  },
                },
                [
                  _c(
                    VBtn,
                    {
                      attrs: { value: "grid" },
                      on: {
                        click: function ($event) {
                          _vm.dataValue.layout = "grid"
                        },
                      },
                    },
                    [_c(VIcon, [_vm._v("mdi-view-grid")])],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    VBtn,
                    {
                      attrs: { value: "list" },
                      on: {
                        click: function ($event) {
                          _vm.dataValue.layout = "list"
                        },
                      },
                    },
                    [_c(VIcon, [_vm._v("mdi-view-list")])],
                    1
                  ),
                ],
                1
              ),
            ]
          }),
        ],
        2
      ),
      _vm._v(" "),
      _c(
        VRow,
        [
          _vm._l(_vm.rows, function (item, index) {
            return [
              _vm.dataValue.layout === "list"
                ? _vm._t(
                    "list",
                    function () {
                      return [
                        _c(
                          "div",
                          { key: index, staticClass: "col-md-12" },
                          [
                            _c(
                              VCard,
                              [
                                _c(VCardTitle, [
                                  _vm._v("this is list slot"),
                                ]),
                                _vm._v(" "),
                                _c(VCardText, [_vm._v(_vm._s(item))]),
                                _vm._v(" "),
                                _c(
                                  VCardActions,
                                  [
                                    _c(VSpacer),
                                    _c(VBtn, [_vm._v("Testing")]),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ]
                    },
                    { data: item, index: index }
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.dataValue.layout === "grid"
                ? _vm._t(
                    "grid",
                    function () {
                      return [
                        _c(
                          "div",
                          { key: index, staticClass: "col-md-4" },
                          [
                            _c(
                              VCard,
                              [
                                _c(VCardTitle, [
                                  _vm._v("this is Grid slot"),
                                ]),
                                _vm._v(" "),
                                _c(VCardText, [_vm._v(_vm._s(item))]),
                                _vm._v(" "),
                                _c(
                                  VCardActions,
                                  [
                                    _c(VSpacer),
                                    _c(VBtn, [_vm._v("Testing")]),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ]
                    },
                    { data: item, index: index }
                  )
                : _vm._e(),
            ]
          }),
        ],
        2
      ),
      _vm._v(" "),
      _c(
        VRow,
        [
          _vm._t("footer", function () {
            return [
              _c(VSpacer),
              _vm._v(" "),
              _c(VPagination, {
                staticClass: "col-md-4",
                attrs: { length: _vm.dataValue.pagination.last_page },
                model: {
                  value: _vm.dataValue.pagination.current_page,
                  callback: function ($$v) {
                    _vm.$set(_vm.dataValue.pagination, "current_page", $$v)
                  },
                  expression: "dataValue.pagination.current_page",
                },
              }),
              _vm._v(" "),
              _c(VSpacer),
            ]
          }),
        ],
        2
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }